export const adaptEstadoPaciente = (estadoPaciente) => {
  const { idEstadoPaciente, codigo, descripcion } = estadoPaciente;

  return {
    id: idEstadoPaciente,
    displayName: descripcion,
  };
};

export const adaptEstadoPacienteArray = (adaptAllEstadoPaciente) => {
  return (
    structuredClone(adaptAllEstadoPaciente?.allEstadoPaciente)?.map(
      (estadoPaciente) => adaptEstadoPaciente(estadoPaciente)
    ) || []
  );
};
